/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { useRef, useState } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';

import EmbedYoutubeModal from 'components/embedYoutubeModal';
import {
  EstimatedFundingUnit,
  FundingUnit,
  HighUnit,
  KnockoutPriceUnit,
  LowUnit,
  MaturityUnit,
  // dateFormat,
  NextFunding,
  NextFundingTicker,
  OiUnit,
  SettlementUnit,
  StrikePrice,
  TickerUnitWrapper,
  VolumeUnit,
} from 'components/Header/partials/tickerUnit';
import Render from 'components/render';
import SelectedProductSpotPrice from 'components/spotPrice';
import { IS_RN_WEBVIEW, OPTIONS_YOUTUBE_VIDEO } from 'constants/constants';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import { isFutures, isTurbo } from 'helpers/utils';
import { isUserLoggedInSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import { ArrowDownThin } from 'styles/assets/icons';
import { ContractType } from 'types/IProducts';

import styles from './index.module.scss';
import PriceAlert from './priceAlert/priceAlert';

const Mobile24hrHeader = ({ selectedProduct, showFullHeader, setShowFullHeader }) => {
  const { t } = useTranslation(['trading', 'markets']);
  const { symbol, contract_type, spot_index } = selectedProduct;
  const headerRef = useRef();
  const showStrikePrice = contract_type.includes(ContractType.MoveOptions);
  const showKnockOutPrice = isTurbo(contract_type);
  const isIrs = contract_type === ContractType.InterestRateSwaps;
  const isNotSpotContract = contract_type !== ContractType.Spot;
  const isTracker = contract_type === ContractType.Tracker;
  const showIndexPrice = isNotSpotContract && !isFutures(contract_type);
  const [showVideo, setShowVideo] = useState(false);
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);
  const onToggle = () => {
    if (showFullHeader) {
      headerRef.current.style.maxHeight = '40px';
    } else {
      headerRef.current.style.maxHeight = '170px';

      trackMixpanelEvent('Contract Page View Clicked - Trade', {
        product_name: symbol,
        product_type: contract_type,

        source: `Mobile - Chart/Book`,
      });
    }
    setShowFullHeader(!showFullHeader);
  };

  const RenderSecondElement = () => {
    switch (contract_type) {
      case ContractType.PerpetualFutures:
        return <FundingUnit product={selectedProduct} />;
      case ContractType.Futures:
      case ContractType.PutOptions:
      case ContractType.CallOptions:
      case ContractType.MoveOptions:
      case ContractType.Spreads:
      case ContractType.OptionsCombos:
        return <SettlementUnit product={selectedProduct} />;
      case ContractType.InterestRateSwaps:
        return <NextFunding product={selectedProduct} />;
      case ContractType.Spot:
      case ContractType.Tracker:
        return <HighUnit product={selectedProduct} />;
      default:
        return <div data-palette="RenderSecondElement" />;
    }
  };

  const showPriceAlert =
    isFutures(contract_type) &&
    spot_index?.config?.price_alert_enabled &&
    isUserLoggedIn &&
    IS_RN_WEBVIEW;

  return (<>
    <div
      className={cx('row', styles['mobile-header-change-container'])}
      ref={headerRef}
      data-palette="Mobile24hrHeader">
      <div className="d-flex w-100 relative">
        {showIndexPrice && (
          <TickerUnitWrapper className={cx('mt-0', styles.cell)}>
            <div className="header-label">{t('markets:optionsTable.indexPrice')}</div>
            <div className="header-value">
              <SelectedProductSpotPrice />
            </div>
          </TickerUnitWrapper>
        )}
        <div className={cx('mt-0', styles.cell)}>
          <VolumeUnit product={selectedProduct} />
        </div>

        <div className={cx('mt-0', styles.cell)}>
          {isNotSpotContract && !isTracker ? (
            <OiUnit product={selectedProduct} />
          ) : (
            <RenderSecondElement />
          )}
        </div>
        <div className={styles['button-icon-container']}>
          <MediaQuery query={device.down.xs}>
            <Render when={showPriceAlert}>
              <PriceAlert product={selectedProduct} />
            </Render>
          </MediaQuery>

          {isNotSpotContract ? (
            <div
              data-testid="expandHeaderArrow"
              aria-hidden="true"
              className={cx(styles.headerToggle, {
                [styles.activeHeadertoggle]: showFullHeader,
              })}
              onClick={onToggle}
              data-palette="Mobile24hrHeader">
              <ArrowDownThin
                className={cx({
                  [styles.rotate]: showFullHeader,
                })}
              />
            </div>
          ) : (
            <div className={cx('mt-0', styles.cell)} data-palette="Mobile24hrHeader">
              <LowUnit product={selectedProduct} />
            </div>
          )}
        </div>
      </div>
      {showFullHeader ? (
        <div className="d-flex flex-wrap w-100" data-palette="Mobile24hrHeader">
          {isNotSpotContract && !isTracker ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <RenderSecondElement />
            </div>
          ) : null}
          {showStrikePrice ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <StrikePrice product={selectedProduct} />
            </div>
          ) : null}
          {showKnockOutPrice ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <KnockoutPriceUnit product={selectedProduct} />
            </div>
          ) : null}
          {isIrs ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <MaturityUnit product={selectedProduct} />
            </div>
          ) : null}
          {contract_type === 'perpetual_futures' ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <EstimatedFundingUnit product={selectedProduct} />
            </div>
          ) : null}
          {contract_type === 'perpetual_futures' ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <NextFundingTicker product={selectedProduct} />
            </div>
          ) : null}
          {contract_type !== 'spot' && !isTracker ? (
            <div className={styles.cell} data-palette="Mobile24hrHeader">
              <HighUnit product={selectedProduct} />
            </div>
          ) : null}
          <div className={styles.cell}>
            <LowUnit product={selectedProduct} />
          </div>
        </div>
      ) : null}
    </div>
    <EmbedYoutubeModal
      src={OPTIONS_YOUTUBE_VIDEO}
      isOpen={showVideo}
      onClose={() => setShowVideo(false)}
    />
  </>);
};

export default Mobile24hrHeader;
